export default __webpack_public_path__ + "static/media/top_of_curl.dabcfe0b.svg";